import { graphql } from 'gatsby';
import { gql } from '@apollo/client';

export const ProductDetailsQuery = graphql`
  fragment ProductDetails on WpSimpleProduct {
    databaseId
    id
    uri
    title
    shortDescription
    price
    regularPrice
    onSale
    featured
    stockStatus
    productFields {
      brand
      new
    }
    image {
      gatsbyImage(width: 600, quality: 75)
    }
    productCategories {
      nodes {
        id
        name
      }
    }
    galleryImages {
      nodes {
        altText
        gatsbyImage(width: 600, quality: 75)
      }
    }
  }
`;

export const PRODUCT_CATEGORY_FILTER_DETAILS = graphql`
  fragment CategoryFilterDetails on WpProductCategory {
    databaseId
    id
    uri
    name
    count
    wpChildren {
      nodes {
        id
        name
        uri
        count
      }
    }
  }
`;

export const PRODUCT_FRAGMENT = gql`
  fragment ProductFragment on SimpleProduct {
    name
    sku
    uri
    databaseId
    price(format: RAW)
    image {
      sourceUrl(size: WOOCOMMERCE_THUMBNAIL)
    }
  }
`;

export const CART_FRAGMENT = gql`
  fragment CartFragment on Cart {
    total
    contentsTotal
    shippingTotal(format: RAW)
    shippingTax(format: RAW)
    discountTotal(format: RAW)
    discountTax(format: RAW)
    availableShippingMethods {
      rates {
        id
        label
        cost
      }
    }
    chosenShippingMethods
    contents {
      itemCount
      nodes {
        quantity
        key
        product {
          node {
            ...ProductFragment
          }
        }
      }
    }
  }
`;

export const INSTAGRAM_FRAGMENT = graphql`
  fragment InstagramDetails on WpPage {
    homepageFields {
      instagram {
        post {
          image {
            gatsbyImage(width: 300, height: 300, layout: FULL_WIDTH)
          }
          url
          isVideo
        }
      }
    }
  }
`;
